import { CustomerCancellationStepContent } from 'app/modules/cms/model/customer-cancellation-step-content-model';
import { CustomerConfirmationStepContent } from '../model/customer-confirmation-step-content-model';
import { CustomerConfirmationBarcodeStep } from '../model/customer-confirmation-barcode-step-model';
import { CustomerInsuredStepContent } from '../model/customer-insured-step-content-model';
import { CustomerOffersStepContent } from '../model/customer-offers-step-content-model';
import { CustomerSubscriberStepContent } from '../model/customer-subscriber-step-content-model';
import { CustomerSummaryStepContent } from '../model/customer-summary-step-content-model';
import { CustomerTooLatetepContent } from '../model/customer-tooLate-step-content-model';
import { CustomerTooEarlyStepContent } from '../model/customer-tooEarly-step-content-model';
import { CustomerPaymentStepContent } from '../model/customer-payment-step-content-model';
import { CustomerPaymentConfirmationStepContent } from '../model/customer-payment-confirmation-step-content-model';
import { CustomerPaymentFailureStepContent } from '../model/customer-payment-failure-step-content-model';

export enum CmsPageContentType {
  CUSTOMER_OFFERS_STEP_CONTENT = 'customer_offers_step_content',
  CUSTOMER_SUMMARY_STEP_CONTENT = 'customer_summary_step_content',
  CUSTOMER_SUBSCRIBER_STEP_CONTENT = 'customer_subscriber_step_content',
  CUSTOMER_ESIGN_STEP_CONTENT = 'customer_esign_step_content',
  CUSTOMER_CONFIRMATION_STEP_CONTENT = 'customer_confirmation_step_content',
  CUSTOMER_CONFIRMATION_BARCODE_STEP = 'customer_confirmation_barcode_step',
  CUSTOMER_CANCELLATION_STEP_CONTENT = 'customer_cancellation_step_content',
  CUSTOMER_INSURED_STEP_CONTENT = 'customer_insured_step_content',
  VENDOR_CUSTOMER_STEP_CONTENT = 'VENDOR_CUSTOMER_STEP_CONTENT',
  CUSTOMER_TOOLATE_STEP_CONTENT = 'customer_toolate_step_content',
  CUSTOMER_TOOEARLY_STEP_CONTENT = 'customer_tooearly_step_content',
  INSURED_ELEMENT_STEP_CONTENT = 'insured_element_step_content',
  APP_GLOBAL_TYPE = 'app_global_type',
  CUSTOMER_PAYMENT_STEP_CONTENT = 'customer_payment_step_content',
  CUSTOMER_PAYMENT_CONFIRMATION_STEP_CONTENT = 'customer_payment_confirmation_step_content',
  CUSTOMER_PAYMENT_FAILURE_STEP_CONTENT = 'customer_payment_failure_step_content'
}

export type CmsPageContentReturnType =
  | CustomerOffersStepContent
  | CustomerSubscriberStepContent
  | CustomerSummaryStepContent
  | CustomerConfirmationStepContent
  | CustomerConfirmationBarcodeStep
  | CustomerCancellationStepContent
  | CustomerInsuredStepContent
  | CustomerTooLatetepContent
  | CustomerTooEarlyStepContent
  | CustomerPaymentStepContent
  | CustomerPaymentConfirmationStepContent
  | CustomerPaymentFailureStepContent;

export const cmsLanguages = () => {
  const language = localStorage.getItem('language');
  if (language.toLowerCase() === 'it' || language.toLowerCase() === 'it-IT') {
    return 'it-IT';
  } else if (language.toLowerCase() === 'en' || language.toLowerCase() === 'en-EN') {
    return 'en-EN';
  } else {
    return 'fr-FR';
  }
};
